import { useState, useEffect, useRef } from 'react';
import {localeDatetime, checkEmail} from "Services/utils";
import EVENTS_API from "Services/EventAPI";
import LetterGif from 'assets/images/mail-animation.gif';
import { useTranslation } from "react-i18next";

function PopupReserve(props) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenAlreadyStart, setIsOpenAlreadyStart] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasTicket, setHasTicket] = useState(false);
    const popupRef = useRef(null);
    const togglePopup = () => {
        setHasTicket(false);
        setIsOpen(!isOpen);
        setCodeErr(null);
        setResponse(null);
        if (isOpen) {
            props.reload();
        }
    };

    const reserve = () => {
        if (props.data?.event.isAlreadyStart) {
            setIsOpenAlreadyStart(true);
            setIsOpen(false);
            setCodeErr(null);
            setResponse(null);
        }else{
            togglePopup();
        }
    };

    const [data, setData] = useState({
        name: {value:"", err: null},
        email: {value: "", err: null},
        notification: {value: false},
    });
    const [codeErr, setCodeErr] = useState(null);

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            setData({...data, name:{...data.name, value: props.codeData?.name}, email:{...data.email, value:  props.codeData?.email}})
        }
        return () => {
            isMounted = false;
        }
    }, [props.codeData?.name, props.codeData?.email]);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            e.stopPropagation();
            if (e.target.getAttribute('name') === 'popupOverlay') {
                isOpen && togglePopup();
            }
            
            if (e.target.getAttribute('name') === 'popupAlreadyStartOverlay') {
                isOpenAlreadyStart && setIsOpenAlreadyStart(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [isOpen]);
    const handleChanegData = (e) => {
        const {name, value, type, checked} = e.currentTarget;
        if (type !== "text") {
            setData({...data, [name]: {...data[name], value: !data[name].value}});
            return;
        }
        setData({...data, [name]: {...data[name], value: value}});
    }

    const handleReserveTicket = () => {
        setIsLoading(true);
        let err = {name: null, email: null};
        setCodeErr(null);
        if (!checkEmail(data.email.value)) {
            err.email = 'book.form.email.err.invalid';
        }
        const name = data.name.value?.trim();
        if (name === '') {
            err.name = 'book.form.name.err.empty';
        }

        if (err.email || err.name) {
            setData({
                ...data,
                name: {...data.name, err: err.name},
                email: {...data.email, err: err.email},
            });
            setIsLoading(false);
            return;
        }

        setData({
            ...data,
            name: {...data.name, err: null},
            email: {...data.email, err: null},
        });

        // Create a new object without the 'err' attributes
        const payload = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [key, value.value])
        );
        payload.code = props.code;
        payload.eventDateId = props.eventDateId;
        payload.language = props.language;
        payload.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        payload.url = `${window.location.protocol}//${window.location.hostname}`;
        payload.createTicket = true;

        if (hasTicket) {
            payload.hasTicket = true;
            payload.createTicket = props.data?.event.free ? false : false;
        }

        EVENTS_API.reserveTicket(payload)
            .then((res)=>{
                setResponse({title: "book.ok", message: "book.ok.txt", reserved: true});
            }).catch((err)=>{
                if (err?.response) {
                    const {msg} = err?.response?.data;
                    if (msg === 'Code Not Found') {
                        setCodeErr('err.invalid');
                    }else if (msg === 'Code Expired') {
                        setCodeErr('err.expire');
                    }else if (msg === 'Code Used') {
                        setCodeErr('err.used');
                    }else if (msg === 'Code is oft canceled') {
                        setCodeErr('err.used');
                    }else if (msg === 'Code does not match any event') {
                        setCodeErr('err.noEvent');
                    }else if (msg === 'Date is Sold Out') {
                        setResponse({title: "book.err.soldout", message: "book.err.soldout.txt", reserved: false});
                    }else if (msg === 'Ticket found') {
                        setHasTicket(true);
                    }/*else if (msg === 'Date will start soon') {
                        setResponse({title: "book.err.startSoon", message: "book.err.startSoon.txt", reserved: false});
                    }*/
                }else{
                    setResponse({title: "book.err.unkown", message: "book.err.unkown.txt", reserved: false});
                }
                console.log('response: ', err.response);
                console.log('err: ', err);
            }).finally(() =>{
                setIsLoading(false);
            })
    }

    const [response, setResponse] = useState(null);

    return (
        <div>
            {/* Button to toggle the popup */}
            <button className='wb-button-blue' ref={props.data.btnOpen.ref} onClick={reserve} disabled={props.disabled} title={t(props.data.btnOpen?.tt)}>{t(props.data.btnOpen?.txt)}</button>

            {/* Popup content */}
            {isOpen && (
                <div name="popupOverlay" className="wb-popup" ref={popupRef}>
                    <div className="wb-popup-content">
                        <div style={{position: "relative"}}>
                            <span onClick={togglePopup} className="wb-close-x">&#10005;</span>
                        </div>
                        {response === null && <>
                            <h2>{t(props.data.title)}</h2>
                            <p>{t(props.data.body.p)}</p>
                            <div className='wb-mb-3' style={{fontSize: "13px"}}>
                                <div dangerouslySetInnerHTML={{__html: t("book.form.event.title",{name: props.data.event.title})}} />
                                <div dangerouslySetInnerHTML={{__html: t("book.form.event.subtitle",{scope: props.data.event.title})}} />
                                <div dangerouslySetInnerHTML={{__html: t("book.form.event.date",{date: localeDatetime(props.data.event.date, null, false, true)})}} />
                                <div dangerouslySetInnerHTML={{__html: t("book.form.event.time",{time: localeDatetime(props.data.event.date, null, true, false)})}} />
                            </div>
                            <div className='wb-mb-3' style={{fontSize: "13px"}} >
                                <div className='wb-grid-container wb-mb-1'>
                                    <label className='wb-grid-item-6 wb-label' htmlFor="name">{t("book.form.code")}</label>
                                    <input 
                                        className='wb-grid-item-6 wb-input'
                                        id="code"
                                        name="code"
                                        type="text"
                                        disabled={true}
                                        value={props.code}
                                    />
                                    {codeErr && <p className='err-input'>{codeErr}</p>}
                                </div>
                                <div className='wb-grid-container wb-mb-1'>
                                    <label className='wb-grid-item-6 wb-label' htmlFor="name">{t("book.form.name")}</label>
                                    <input 
                                        className='wb-grid-item-6 wb-input'
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder={t("book.form.name.hint")}
                                        disabled={isLoading || (hasTicket && props.data?.event.free)}
                                        value={data.name.value}
                                        onChange={handleChanegData}
                                    />
                                    {data.name.err && <p className='err-input'>{data.name.err}</p>}
                                </div>
                                <div className='wb-grid-container'>
                                    <label className='wb-grid-item-6 wb-label' htmlFor="email">{t("book.form.email")}</label>
                                    <input 
                                        className='wb-grid-item-6 wb-input'
                                        id="email"
                                        name="email"
                                        type="text"
                                        placeholder={t("book.form.email.hint")}
                                        disabled={isLoading || (hasTicket && props.data?.event.free)}
                                        value={data.email.value}
                                        onChange={handleChanegData}
                                    />
                                    {data.email.err && <p className='err-input'>{data.email.err}</p>}
                                </div>
                            </div>
                            <div className='wb-grid-container' style={{fontSize: "13px"}}>
                                <p className="wb-grid-item-6">
                                    {t("book.form.notify")}
                                </p>
                                {!props.data?.event?.startInNext24Hours && <div className="wb-grid-item-6  wb-mb-3">
                                    <span>
                                        <input
                                            //style={checkboxAgreeStyle}
                                            disabled={isLoading}
                                            name='notification'
                                            id='notification'
                                            type="checkbox"
                                            style={{marginRight:'5px'}}
                                            checked={data.notification.value}
                                            onChange={handleChanegData}
                                            value={data.notification.value}
                                        />
                                        <label htmlFor='notification'>{t("book.form.notify.later", {hours:props.data?.event.notifyPreHours})}</label>
                                    </span>
                                </div>}
                            </div>
                            <div className='wb-grid-container wb-mb-4 wb-mt-1' style={{fontSize: "13px"}}>
                                <p className="wb-grid-item-6">
                                    {props.data?.event?.startInNext24Hours ? t("book.form.retract") : t("book.form.retract.later")}
                                </p>
                            </div>
                            
                            <div className='wb-grid-container wb-mb-2' style={{fontSize: "13px"}}>
                                <div className="wb-grid-item-6">
                                    <button className='wb-btn-light-grey' style={{float: "left"}} onClick={togglePopup}>{t("book.form.btn.cancel")}</button>
                                  
                                    <button 
                                        className='wb-button-blue'
                                        style={{float: "right"}}
                                        onClick={handleReserveTicket}
                                        disabled={isLoading}
                                    >
                                        {hasTicket && props.data?.event.free && t("book.form.btn.notify")}
                                        {hasTicket && !props.data?.event.free && t("book.form.btn.continue")}
                                        {!hasTicket && t("book.form.btn.confirm")}
                                    </button>
                                </div>
                            </div>
                        </>}
                        {response && <>
                            <h2>{t(response.title)}</h2>
                            {response.reserved && 
                                <div className="wb-center-hw">
                                    <img
                                        src={process.env.PUBLIC_URL + LetterGif}
                                        className="wb-letter-img"
                                        alt="Mail Icon"
                                        loading="lazy"
                                    />
                                </div>
                            }
                            <p className='wb-mt-4' dangerouslySetInnerHTML={{__html: t(response.message)}} />
                            <button className='wb-button-blue wb-mt-2' style={{fontSize: "13px", float: "right"}} onClick={togglePopup}>{t("btn.close")}</button>
                        </>}
                    </div>
                </div>
            )}
            {isOpenAlreadyStart && 
                 <div name="popupAlreadyStartOverlay" className="wb-popup">
                 <div className="wb-popup-content">
                     <div style={{position: "relative"}}>
                         <span onClick={(e) => setIsOpenAlreadyStart(false)} className="wb-close-x">&#10005;</span>
                     </div>
                     <h2>{t('book.wrn.startSoon')}</h2>
                     <p style={{fontSize: "13px"}}>{t('book.wrn.startSoon.txt')}</p>
                     <div className='wb-grid-container wb-mb-2 wb-mt-4' style={{fontSize: "13px"}}>
                        <div className="wb-grid-item-6">
                            <button 
                                className='wb-btn-light-grey'
                                style={{float: "left"}}
                                onClick={(e) => setIsOpenAlreadyStart(false)}
                            >{t("book.form.btn.cancel")}</button>
                            <button
                                title={t('book.wrn.startSoon.txt.btn.tt')}
                                className='wb-button-blue'
                                style={{float: "right"}}
                                onClick={(e) => {
                                    setIsOpen(true);
                                    setIsOpenAlreadyStart(false)
                                }}
                            >{t("book.wrn.startSoon.txt.btn")}</button>
                        </div>
                    </div>
                 </div>
             </div>
            }
        </div>
    );
}

export default PopupReserve;